import { create } from 'zustand';
import { persist } from 'zustand/middleware';

/** Product-comparison tray. Holds up to 4 product ids; the CompareBar +
 *  comparison modal read from here. Persisted so the selection survives
 *  navigation between catalog and product pages. */
const MAX_COMPARE = 4;

interface CompareStore {
  ids: string[];
  toggle: (id: string) => void;
  remove: (id: string) => void;
  clear: () => void;
  has: (id: string) => boolean;
}

export const useCompareStore = create<CompareStore>()(
  persist(
    (set, get) => ({
      ids: [],
      toggle: (id) => {
        const { ids } = get();
        if (ids.includes(id)) {
          set({ ids: ids.filter((x) => x !== id) });
        } else if (ids.length < MAX_COMPARE) {
          set({ ids: [...ids, id] });
        }
      },
      remove: (id) => set({ ids: get().ids.filter((x) => x !== id) }),
      clear: () => set({ ids: [] }),
      has: (id) => get().ids.includes(id),
    }),
    { name: 'compare-storage' },
  ),
);

export const COMPARE_MAX = MAX_COMPARE;
